import { Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import { useLang } from "@/context/LanguageContext";
import { UPCOMING } from "@/lib/upcoming";
import { MandalaMotif } from "@/components/MotifBackground";
import {
  GraduationCap, Video, Flame, Sunrise, AudioLines, HandCoins,
  HeartHandshake, Repeat, MessagesSquare, HelpCircle, Baby, ArrowRight, Sparkles,
} from "lucide-react";

const ICONS = {
  GraduationCap, Video, Flame, Sunrise, AudioLines, HandCoins,
  HeartHandshake, Repeat, MessagesSquare, HelpCircle, Baby,
};

export default function ComingSoonIndex() {
  const { pick } = useLang();
  return (
    <>
      <Helmet>
        <title>Coming Soon · Dharmartha</title>
        <meta name="description" content="New ways to learn, worship and participate — courses, live darshan, daily pooja, crowdfunding, discussions and more, coming soon to Dharmartha." />
      </Helmet>

      <section className="relative overflow-hidden border-b border-line bg-[var(--parchment)]">
        <MandalaMotif className="pointer-events-none absolute -right-28 -top-20 hidden h-[520px] w-[520px] text-[var(--gold)] opacity-[0.05] md:block" />
        <div className="relative z-[2] mx-auto max-w-3xl px-5 py-20 text-center md:px-8">
          <p className="overline-label mb-4 inline-flex items-center gap-2 text-gold">
            <span className="h-px w-6 bg-[var(--gold)]" />
            {pick("शीघ्र आ रहा है", "Coming Soon")}
            <span className="h-px w-6 bg-[var(--gold)]" />
          </p>
          <h1 className="font-deva text-4xl leading-tight text-ink sm:text-5xl lg:text-6xl">आगामी सुविधाएँ</h1>
          <p className="mt-3 font-serif-latin text-xl text-ink-2 sm:text-2xl">{pick("धर्मार्थ पर शीघ्र", "Arriving soon on Dharmartha")}</p>
          <p className="mx-auto mt-6 max-w-xl text-base leading-relaxed text-ink-2">
            {pick(
              "सीखने, उपासना और सहभागिता के नए मार्ग — हम इन्हें श्रद्धा एवं प्रामाणिकता के साथ तैयार कर रहे हैं।",
              "New ways to learn, worship and take part — we're building each of these with care and authenticity.")}
          </p>
        </div>
      </section>

      <section className="bg-surface">
        <div className="mx-auto max-w-6xl px-5 py-16 md:px-8">
          <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
            {UPCOMING.map((u) => {
              const Icon = ICONS[u.icon] || Sparkles;
              return (
                <Link key={u.slug} to={u.path} data-testid={`coming-card-${u.slug}`} className="group flex flex-col border border-line bg-parchment p-6 transition-colors hover:border-saffron">
                  <div className="flex items-center justify-between">
                    <span className="flex h-11 w-11 items-center justify-center border border-line bg-surface text-saffron transition-colors group-hover:border-saffron">
                      <Icon className="h-5 w-5" />
                    </span>
                    <span className="border border-line px-2 py-0.5 text-[10px] uppercase tracking-[0.12em] text-ink-3">{pick("शीघ्र", "Soon")}</span>
                  </div>
                  <h2 className="mt-5 font-deva text-2xl text-ink">{u.hi}</h2>
                  <p className="mt-0.5 font-serif-latin text-sm text-ink-3">{u.en}</p>
                  <p className="mt-3 flex-1 text-sm leading-relaxed text-ink-2">{pick(u.desc_hi, u.desc_en)}</p>
                  <span className="mt-5 inline-flex items-center gap-1.5 text-xs font-medium text-saffron">
                    {pick("और जानें", "Learn more")} <ArrowRight className="h-3.5 w-3.5 transition-transform group-hover:translate-x-0.5" />
                  </span>
                </Link>
              );
            })}
          </div>
        </div>
      </section>
    </>
  );
}
